<template>
  <v-layout row>
    <v-flex xs12>
    <v-toolbar app>
    <!-- <v-btn icon><v-icon>keyboard_arrow_left</v-icon></v-btn> -->
    <v-toolbar-title>Datos de la cuenta</v-toolbar-title>
    <v-spacer></v-spacer>
     <v-btn icon @click="logOut">
        <v-icon color="red darken-1">exit_to_app</v-icon>
      </v-btn>
  </v-toolbar>
        <div v-if="profile.length > 0">
          <v-list two-line class="list-view">
          <template  >
            <v-list-tile class="list-view-item"
              avatar
              ripple
             
            >
              <v-list-tile-content>
                <v-list-tile-title :class="'bg-blue pack-title'">Datos de la cuenta</v-list-tile-title> 
               
                <table class="pack-list-table has-btn">
                  <tr v-if="profile[0].codigo!=''">
                    <th>Codigo </th>
                    <td>{{profile[0].codigo}}</td>
                  </tr>
                  <tr v-if="profile[0].nombre!=''">
                    <th>Nombre </th>
                    <td>{{profile[0].nombre}}</td>
                  </tr>
                  <tr v-if="profile[0].descripcion_oficina!=''">
                    <th>Oficina </th>
                    <td>{{profile[0].descripcion_oficina}}</td>
                  </tr>
                  <tr v-if="profile[0].direccion_oficina!=''">
                    <th>Dirección Oficina</th>
                    <td>{{profile[0].direccion_oficina}}</td>
                  </tr>
                  <tr v-if="profile[0].email_address_oficina!=''">
                    <th>Email Oficina</th>
                    <td>{{profile[0].email_address_oficina}}</td>
                  </tr>
                  <tr v-if="profile[0].telefono1_oficina!=''">
                    <th>Telefono 1</th>
                    <td>{{profile[0].telefono1_oficina}}</td>
                  </tr>
                  <tr v-if="profile[0].telefono2_oficina!=''">
                    <th>Telefono 2</th>
                    <td>{{profile[0].telefono2_oficina}}</td>
                  </tr>
                                    
                </table>
              </v-list-tile-content>
            </v-list-tile>

          </template>
           <template  >
            <v-list-tile class="list-view-item"
              avatar
              ripple
             
            >
              <v-list-tile-content>
                <v-list-tile-title :class="'bg-blue pack-title'">Dirección Miami</v-list-tile-title> 
               
                <table class="pack-list-table  has-btn">
                  <tr v-if="profile[1].DIRECCION_FULL!=''">
                    <th>Dirección Completa </th>
                    <td>{{profile[1].DIRECCION_FULL}}</td>
                  </tr>
                  <tr v-if="profile[1].address1!=''">
                    <th>Address 1 </th>
                    <td>{{profile[1].address1}}</td>
                  </tr>
                  <tr v-if="profile[1].address2!=''">
                    <th>Address 2 </th>
                    <td>{{profile[1].address2}}</td>
                  </tr>
                  <tr v-if="profile[1].city !=''">
                    <th>City</th>
                    <td>{{profile[1].city}}</td>
                  </tr>
                  <tr v-if="profile[1].state !=''">
                    <th>State</th>
                    <td>{{profile[1].state}}</td>
                  </tr>
                  <tr v-if="profile[1].telefono_direccion!=''">
                    <th>Telefono</th>
                    <td>{{profile[1].telefono_direccion}}</td>
                  </tr>
                  <tr v-if="profile[1].zipcode !=''">
                    <th>Zipcode</th>
                    <td>{{profile[1].zipcode}}</td>
                  </tr>
                                    
                </table>
              </v-list-tile-content>
            </v-list-tile>

          </template>
        </v-list>
          <div class="pl-3 pr-3 pb-5">
            <v-btn color="error" @click="logOut" large block >Salir</v-btn> 
          </div>
        </div>
        <div v-else>
          <img src="../assets/nodatos.jpg" class="noData" alt="" v-if="noData">
          <v-progress-circular
            :size="90"
            color="blue"
            indeterminate
            class="loading-center"
          ></v-progress-circular>
          
        </div>
         
        </v-flex>
        
        
  </v-layout>

         
        
</template>

<script>
  import Helpers from '../utils/helpers'
  import Server from '../utils/server'
export default {
  created() {
    this.$store.watch(
      (state, getters) => getters.user, 
      (newValue, oldValue) => {
        console.log(newValue) 
        this.currentUser = newValue;
        if (newValue.pushId !== null && newValue.userName !== null) {
          if(this.currentUser != undefined){
            console.log(this.currentUser);
            this.getPacks();  
          }
          
        }
      },
    );
  },
  mounted () {
    if(this.currentUser != undefined){
      this.getPacks();  
    }else if(this.user.userName != null ){
      this.currentUser = this.user;
      this.getPacks(); 
    }
  },
  data () {
    return {
      clipped: false,
      currentUser: undefined
    }
  },
  computed: {
    noData(){
      return (this.profile.length > 0)? true: false;
    },
    login: function () {
      return this.$store.getters.login
    }, 
    user: function(){
      return this.$store.getters.user
    },
    profile: function(){
      return this.$store.getters.profile
    }
  },
  methods: {
    logOut(){
      
      this.$store.dispatch('logout');
      window.MobileApi.signOut();   

      var formData = new FormData()
        formData.append('text1', this.currentUser.userName)
        formData.append('text3', this.currentUser.pushId)
        formData.append('device', window.MobileApi.device)
      this.$http.post(Server.logout, formData)   
          .then( 
            response => {
              
            },
            () => {
              
            }
          );
    },
    getPacks(){
      var formData = new FormData()
        formData.append('text1', this.currentUser.userName)
        formData.append('text3', this.currentUser.pushId)
        formData.append('device', window.MobileApi.device)

        this.$store.dispatch('getProfile', {Vue:this,url:Server.profile,data:formData});

    }
  },
  name: 'App'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
